<template>
  <div class="table-responsive open-positions-modal__table d-none d-lg-block">
    <table class="table table-bordered mb-0">
      <thead>
        <tr>
          <th class="align-middle" scope="col">
            <button
              class="btn btn-manatt-black table-header-btn py-0 ps-1"
              aria-label="Sort by Title"
            >
              Title
              <IconCaretDownFill />
            </button>
          </th>
          <th class="align-middle" scope="col">Department</th>
          <th class="align-middle" scope="col">Location</th>
          <th class="align-middle" scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in openPositionModalStore.items" :key="item.id">
          <td class="align-middle">
            <div class="open-positions-modal__table__title">
              <span>{{ item.title }}</span>
            </div>
          </td>
          <td class="align-middle">
            <div class="open-positions-modal__table__department">
              <p>{{ item.department }}</p>
            </div>
          </td>
          <td class="align-middle">
            <div class="open-positions-modal__table__location">
              <p>{{ getLocation(item).elements?.title?.value }}</p>
            </div>
          </td>
          <td class="align-middle">
            <button :class="`btn btn-manatt-black w-100 table-item-btn`" @click="navigate(item.id)">
              Read More
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="open-positions-modal__list d-lg-none">
    <ul>
      <li v-for="item in openPositionModalStore.items">
        <div
          role="button"
          class="open-positions-modal__list__item card"
          tabindex="0"
          @click="navigate(item.id)"
          @keydown.enter="navigate(item.id)"
          @keydown.space.prevent="navigate(item.id)"
        >
          <div class="open-positions-modal__list__item__text">
            <div class="open-positions-modal__list__item__text__top-row">
              <span>{{ getLocation(item).elements?.title?.value }}</span>
              <span>{{ item.department }}</span>
            </div>
            <div class="open-positions-modal__list__item__text__bottom-row">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useOpenPositionModal } from '~/stores/modals/open-position-modal'
import type { SearchResultOpenPositionItem } from '~/types/SearchResultItem'
import type { LocationPageModel } from '~/models'

const siteStore = useSiteStore()
const pageStore = usePageStore()
const openPositionModalStore = useOpenPositionModal()
const router = useRouter()

const navigate = async (itemId: string) => {
  document.body.classList.remove('modal-open')

  const url = await pageStore.getUrlByItemId(itemId)
  navigateTo(url)
}

function getLocation(item: SearchResultOpenPositionItem) {
  const location =
    pageStore.getLinkedItem<LocationPageModel>(item.location) ??
    siteStore.getLinkedItem<LocationPageModel>(item.location)
  return location ?? ''
}
</script>
